<script setup lang="ts">
/**
 * UI-kit component
 * Category: Selectors
 * Name: 'Radiobuttons'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=7680-2368'
 */
import { computed } from 'vue'

import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { faCircle } from '@fortawesome/pro-regular-svg-icons'
import { faScrubber } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/icon'

defineOptions({
  name: 'BtnRadio',
})

const props = withDefaults(defineProps<BtnRadioProps>(), {
  checked: false,
  disabled: false,
  mode: 'normal',
})

const emit = defineEmits<{
  click: []
}>()

interface BtnRadioProps {
  checked?: boolean
  disabled?: boolean
  mode?: InputMode
}

const handleClick = (): void => {
  if (!props.disabled) {
    emit('click')
  }
}

const icon = computed(() => props.checked ? faScrubber : faCircle)

</script>

<template>
  <button
    :class="['btn-radio', mode, { checked, disabled }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer
      class="medium"
    >
      <FontAwesomeIcon
        :icon="icon"
      />
    </IconContainer>
  </button>
</template>

<style scoped lang="scss" src="./BtnRadio.scss" />
